import Vue from "vue";
import VueI18n from "vue-i18n";

import { DEFAULTLANG } from "@/constans/urlConstans.js";
Vue.use(VueI18n);

const i18n = new VueI18n({
    // 设置默认语言
    locale: DEFAULTLANG, // 语言标识
    // 添加多语言（每一个语言标示对应一个语言文件）
    messages: {
        zh: require("@/assets/i18n/config/zh"),
        en: require("@/assets/i18n/config/en"),
        tc: require("@/assets/i18n/config/tc"),
    },
});
export { i18n };



// WEBPACK FOOTER //
// ./src/assets/i18n/config/i18n.js